import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const GraduationCap: React.FC<Props> = ({ className, ...props }) => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M1.42 3.207L8.741 3a.397.397 0 01.273.1l5.816 5.046c.145.125.204.34.148.536-.056.197-.215.332-.397.337l-1.546.048v1.837c.259.188.434.538.434.94 0 .403-.175.754-.434.94v1.676c0 .298-.192.54-.43.54-.237 0-.43-.242-.43-.54v-1.675c-.259-.187-.433-.538-.433-.94s.174-.753.433-.94v-1.81l-4.923.152a.383.383 0 01-.145-.023.415.415 0 01-.13-.078l-5.81-5.065a.527.527 0 01-.147-.538c.057-.196.216-.33.398-.336zm5.423 6.943c.14.052.287.075.434.071l4.12-.128-.585 2.039c-.142.499-.723.752-1.724.751-.873 0-1.892-.198-2.868-.558-.977-.36-1.904-.878-2.61-1.459C2.798 10.2 2.46 9.61 2.603 9.11l.584-2.04 3.267 2.848c.117.102.248.18.388.232z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
GraduationCap.displayName = 'GraduationCap';

export default GraduationCap;
